<template lang="pug">
  .module-header
    .flex-item
      .catergory-icon
        WtSvgIcon(:icon="moduleIcon" width="40px" height="40px" style="padding-top: 5px;")
        span.category {{ moduleType }}
    .flex-item
      RouterLink(:to="redirectToAll" @click.native.stop)
        WtButton.view-button View all
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "CompanionViewAllHeader",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    moduleIcon: {
      type: String,
      required: true
    },
    moduleType: {
      type: String,
      required: true
    },
    redirectToAll: {
      type: [Object, String],
      required: true
    }
  }
};
</script>

<style scoped>
.module-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .catergory-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  .category {
    color: #1b1d20;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px; /* 125% */
    font-family: Manrope;
    font-style: normal;
    letter-spacing: 0.25px;
  }

  .view-button {
    display: flex;
    padding: 6px 8px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #2972f0;
    color: #fff;
    text-align: center;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
  }
}
</style>
